import "core-js/modules/es.array.map";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { roleProductData, roleProductUpd } from "@/api/role";
export default {
  data: function data() {
    return {
      id: '',
      dialogFormVisible: false,
      gameList: [],
      oList: []
    };
  },
  created: function created() {},
  methods: {
    init: function init(id) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.id = id;
                roleProductData({
                  role_id: id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this.dialogFormVisible = true;
                    res.data.map(function (i) {
                      i.game_show_type = i.game_show_type ? i.game_show_type : 1;
                    });
                    _this.oList = res.data.map(function (i) {
                      return {
                        id: i.id,
                        game_show_type: i.game_show_type
                      };
                    });
                    _this.gameList = res.data;
                  }
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dataReset: function dataReset() {
      this.id = '';
      this.gameList = [];
      this.dialogFormVisible = false;
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      var list = this.gameList.map(function (i) {
        return {
          id: i.id,
          game_show_type: i.game_show_type
        };
      });

      if (!list.length) {
        this.dataReset();
        return;
      }

      roleProductUpd({
        role_id: this.id,
        upd_data: list
      }).then(function (res) {
        if (res.status == 200) {
          if (res.data == 1 && JSON.stringify(_this2.oList) != JSON.stringify(list)) {
            _this2.$Message.success('入口设置已变更请重新选择');

            setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
              return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return _this2.$store.dispatch('d2admin/serchSelect/clearData', 1);

                    case 2:
                      _this2.$router.replace('/');

                    case 3:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            })), 500);
          } else {
            _this2.$Message.success('设置成功');
          }

          _this2.dataReset();
        }
      });
    }
  }
};